<section class="integracao-disparo" aria-label="Integração">
  <div class="abas-origem integracao-disparo__abas" role="tablist" aria-label="Integração">
    <div class="aba aba-ativa integracao-disparo__aba" role="tab" aria-selected="true" [class.disabled]="!podeEditar">
      <span class="aba-icone"></span>
      <span class="aba-label">Integração</span>
    </div>
  </div>

  <div class="integracao-disparo__conteudo">

    <app-slide-toggle-padrao
      labelTrue="Padrão"
      labelFalse="Personalizado"
      [disabled]="!podeEditar || carregandoDetalhe"
      [valor]="!personalizada"
      (changeValue)="alterarTipo($event)">
    </app-slide-toggle-padrao>

    @if (carregando || carregandoDetalhe) {
      <p class="integracao-disparo__select-skeleton" aria-hidden="true"></p>
    } @else if (podeEditar) {
      <app-select-one
        class="integracao-disparo__select"
        label="Selecione a integração"
        placeholder="Selecione"
        heightFormField="36px"
        widthFormField="100%"
        [listaInput]="integracoes"
        [itemSelecionado]="integracaoSelecionada"
        [campo]="'id'"
        [subCampo]="'nome'"
        [habilitarBusca]="true"
        borderColor="#d9d9d9"
        (selecionarItem)="selecionarIntegracao($event)">
      </app-select-one>
    } @else {
      <p class="integracao-disparo__select-somente-leitura">{{ integracaoSelecionada?.nome || 'Nenhuma integração selecionada' }}</p>
    }

    @if (erroCarregamento) {
      <p class="integracao-disparo__erro">{{ erroCarregamento }}</p>
    }

    @if (carregandoDetalhe) {
      <p class="integracao-disparo__aviso" role="status">Carregando dados da integração...</p>
    } @else if (disparoAutomatico.integracao?.id) {
      @if (disparoAutomatico.integracao?.payloadNaoEncontrado) {
        <p class="integracao-disparo__aviso" role="status">Payload da integração não encontrado.</p>
      }
      <div class="integracao-disparo__payload">
        <app-json-editor
          label="Payload"
          altura="220px"
          [autoAjustarAltura]="true"
          [isEditavel]="personalizada && podeEditar"
          [value]="disparoAutomatico.integracao?.payload"
          (changeValue)="atualizarPayload($event)"
          (validoChange)="payloadValido = $event">
        </app-json-editor>

        @if (personalizada) {
          <div class="integracao-disparo__variaveis">
            <button
              type="button"
              class="integracao-disparo__adicionar"
              [disabled]="!podeEditar"
              (click)="adicionarVariavel()">
              Adicionar variável
            </button>

            @if ((disparoAutomatico.integracao?.variaveis?.length ?? 0) > 0) {
              <span class="integracao-disparo__subtitulo">Variáveis</span>
              @for (variavel of disparoAutomatico.integracao?.variaveis ?? []; track variavel.ordem) {
                <div class="integracao-disparo__variavel">
                  <span class="integracao-disparo__chip-marcador">{{ montarMarcador(variavel.ordem) }}</span>
                  <app-select-one
                    [listaInput]="opcoesVariaveis"
                    [itemSelecionado]="opcaoVariavelSelecionada(variavel.campo)"
                    [campo]="'nome'"
                    borderColor="#d9d9d9"
                    placeholder="Selecione"
                    heightFormField="34px"
                    [disabled]="!podeEditar"
                    (selecionarItem)="selecionarVariavel(variavel, $event)">
                  </app-select-one>
                  <button
                    type="button"
                    class="integracao-disparo__remover"
                    aria-label="Remover variável"
                    [disabled]="!podeEditar"
                    (click)="removerVariavel(variavel.ordem)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
            }
          </div>
        } @else if ((disparoAutomatico.integracao?.variaveis?.length ?? 0) > 0) {
          <div class="integracao-disparo__resumo-variaveis">
            <span class="integracao-disparo__subtitulo">Variáveis</span>
            <div class="integracao-disparo__chips">
              @for (variavel of disparoAutomatico.integracao?.variaveis ?? []; track variavel.ordem) {
                <span class="integracao-disparo__chip">
                  <span class="integracao-disparo__chip-marcador">{{ montarMarcador(variavel.ordem) }}</span>
                  {{ variavel.campo }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (mensagemAdvertencia(); as mensagem) {
      <p class="integracao-disparo__aviso" role="status">{{ mensagem }}</p>
    }
  </div>
</section>
